import QuickSettings from 'utils/quicksettings';
import { LOCATIONS_VISIT_ORDER } from '../constants/AppConstants';

export default class CheatController {
  constructor(game) {
    this.game = game;

    // this.game.log('create player cheats', 'naughty!');

    this.wrapper = document.createElement('div');
    this.wrapper.className = 'cheat-window';
    this.wrapper.style.width = '0px';
    this.wrapper.style.height = '100%';
    this.wrapper.style.overflow = 'auto';
    this.wrapper.style.background = 'rgba(0,0,0,0.5)';
    this.wrapper.style.position = 'absolute';
    this.wrapper.style.top = '0';
    this.wrapper.style.right = '0';
    this.wrapper.style.display = 'none';
    this.wrapper.style.width = '200px';

    this.bindedCloseWindow = this.closeWindow.bind(this);
    this.bindedOpenWindow = this.openWindow.bind(this);

    document.body.appendChild(this.wrapper);
  }

  /*
  ==========================================================================================
    MAIN MENU
  ==========================================================================================
  */

  createMainMenu() {
    // quicksettings swallows errors, so catching them... siiiiiiiiiiiiiiiiiiigh
    var menu = QuickSettings.create(0, 0, 'Menu', this.wrapper);
    menu.addButton('Close Window', () => {
      try {
        this.closeWindow();
      } catch (e) {
        console.log(e);
      }
    });
    menu.setDraggable(false);
    return menu;
  }

  /*
  ==========================================================================================
    LANGUAGE MENU
  ==========================================================================================
  */

  createLanguageMenu() {
    var menu = QuickSettings.create(0, 0, 'Language', this.wrapper);
    let selectedCountry = this.game.languagesAvailable[0];
    menu.addDropDown('Language', this.game.languagesAvailable, (e) => {
      selectedCountry = e.value;
    });

    menu.addButton('Load Language', () => {
      try {
        window.location.href = window.location.href.split('?')[0] + '?locale=' + selectedCountry;
      } catch (e) {
        console.log(e);
      }
    });
    menu.setDraggable(false);
    return menu;
  }

  /*
  ==========================================================================================
    PLAYER MENU
  ==========================================================================================
  */

  createPlayerMenu() {
    // quicksettings swallows errors, so catching them... siiiiiiiiiiiiiiiiiiigh
    var menu = QuickSettings.create(0, 0, 'Player Progress', this.wrapper);
    menu.addButton('Unlock All Stickers', () => {
      try {
        LOCATIONS_VISIT_ORDER.forEach((location) => {
          this.game.gameController.player.earnLocationSticker(location);
          this.game.state.start(this.game.state.getCurrentState().key, false, true);
          this.closeWindow();
        });
      } catch (e) {
        console.log(e);
      }
    });
    menu.addButton('Unlock All Activities', () => {
      try {
        LOCATIONS_VISIT_ORDER.forEach((location) => {
          this.game.gameController.player.setSelfieSeen(location);
          this.game.gameController.player.setVideoSeen(location);
          this.game.gameController.player.setSouvenirSeen(location);
          this.game.gameController.player.setPollSeen(location);
          this.game.gameController.player.setFoodGamePlayed(location);
          this.game.gameController.player.setChaseGamePlayed(location);
          this.game.state.start(this.game.state.getCurrentState().key, false, true);
          this.closeWindow();
        });
      } catch (e) {
        console.log(e);
      }
    });
    menu.addButton('Reset Player Data', () => {
      try {
        window.localStorage.clear();
        window.location.reload();
      } catch (e) {
        console.log(e);
      }
    });
    menu.setDraggable(false);
    return menu;
  }

  /*
  ==========================================================================================
    FOOD GAME
  ==========================================================================================
  */

  createFoodGameMenu() {
    var menu = QuickSettings.create(0, 0, 'Food Game', this.wrapper);
    var selectedLocation = LOCATIONS_VISIT_ORDER[0];
    menu.addDropDown(
      'Location',
      LOCATIONS_VISIT_ORDER.map((location) => {
        return location;
      }),
      (e) => {
        selectedLocation = e.value;
      }
    );
    menu.addButton('Play Food Game', () => {
      try {
        this.game.gameController.triggerMiniGameFood({
          cheatlaunched: true,
          locationid: selectedLocation,
        });
        this.closeWindow();
      } catch (e) {
        console.log(e);
      }
    });
    menu.setDraggable(false);
    return menu;
  }

  /*
  ==========================================================================================
    CHASE GAME
  ==========================================================================================
  */

  createChaseGameMenu() {
    var menu = QuickSettings.create(0, 0, 'Chase Game', this.wrapper);
    var selectedLocation = LOCATIONS_VISIT_ORDER[0];
    menu.addDropDown(
      'Location',
      LOCATIONS_VISIT_ORDER.map((location) => {
        return location;
      }),
      (e) => {
        selectedLocation = e.value;
      }
    );
    menu.addButton('Play Chase Game', () => {
      try {
        this.game.gameController.triggerMiniGameChase({
          cheatlaunched: true,
          locationid: selectedLocation,
        });
        this.closeWindow();
      } catch (e) {
        console.log(e);
      }
    });
    menu.setDraggable(false);
    return menu;
  }

  /*
  ==========================================================================================
    CUTSCENE MENU
  ==========================================================================================
  */

  createCutsceneMenu() {
    // quicksettings swallows errors, so catching them... siiiiiiiiiiiiiiiiiiigh
    var menu = QuickSettings.create(0, 0, 'Story Cutscenes', this.wrapper);
    menu.addButton('View Story Intro', () => {
      try {
        this.game.gameController.triggerStoryIntro();
        this.closeWindow();
      } catch (e) {
        console.log(e);
      }
    });
    menu.addButton('View Story Location', () => {
      try {
        this.game.gameController.triggerStoryLocationLeave();
        this.closeWindow();
      } catch (e) {
        console.log(e);
      }
    });
    menu.addButton('View Story Outro', () => {
      try {
        this.game.gameController.triggerStoryOutro();
        this.closeWindow();
      } catch (e) {
        console.log(e);
      }
    });
    menu.setDraggable(false);
    return menu;
  }

  openWindow() {
    if (this.open) {
      return;
    }
    this.open = true;
    this.returnToWelcomeOnClose = false;
    this.wrapper.style.display = 'block';
    this.createCheatWindow();
  }

  closeWindow() {
    this.open = false;
    this.destroyCheatWindow();
    this.wrapper.style.display = 'none';
  }

  createCheatWindow() {
    this.activeMenus = [];

    this.activeMenus.push(this.createMainMenu());
    this.activeMenus.push(this.createPlayerMenu());
    this.activeMenus.push(this.createFoodGameMenu());
    this.activeMenus.push(this.createChaseGameMenu());
    this.activeMenus.push(this.createCutsceneMenu());
    this.activeMenus.push(this.createLanguageMenu());
  }

  destroyCheatWindow() {
    this.activeMenus.forEach((menu, index) => {
      if (menu && menu.destroy) {
        menu.destroy();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./js/app/controller/CheatController.js